'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class continousRiskModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'probability':
				return this.getDisplayValue(name, 'risk');
			case 'package':
			case 'wp_ids':
				return this.getClassifValue('wp_ids', 'wp');			
			case 'type':
				return this.getClassifValue(name, 'risk_type');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}